import { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import { IntakeContext } from '../context/IntakeContext'
// import { Link } from "react-router-dom";
import { selectData } from 'layouts/onboarding'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

// @mui material components
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import Box from '@mui/material/Box'

// Soft UI Dashboard PRO React icons
import HelpIcon from '@mui/icons-material/Help'
import { IconButton, Tooltip, Fade } from '@mui/material'

import { UpdatePopup } from 'layouts/onboarding/UpdatePopup'

const StyledMSB = styled.div`
  text-align: center;
  position: relative;
  padding: 16px;
  height: 100%;
  cursor: pointer;
  border: ${(props) =>
    props.active ? '2px solid #a3a7aa' : '2px solid #e5e5e5'};
  background: ${(props) => (props.active ? '#eeeeee' : '#fff')};
  color: #212121;
  border-radius: 0.75rem;
  transition: 0.2s all ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:hover {
    border: 2px solid #a3a7aa;
    background: #f5f5f5;
  }

  > h6,
  h5 {
    color: #212121;
    letter-spacing: 0.3px;
    font-weight: 600;
    line-height: 1.4;
    margin: 0;
  }

  > span {
    border-radius: 50%;
    height: 1.5em;
    width: 1.5em;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.yesIcon {
      color: #4caf50;
      background-color: #dbefdc;
    }
    &.noIcon {
      color: #fd5c70;
      background-color: #fedee2;
    }
  }
`

const OnboardingMaritalStatus = ({
  id,
  preHeader,
  header,
  subHeader,
  helpText,
}) => {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)

  const [tileValue, setTileValue] = useState(intakeState?.[id])

  const toggleTileValue = (name) => {
    setTileValue(name)
  }

  useEffect(() => {
    if (typeof tileValue != 'string') return
    updateIntakeStateAtKey({
      [id]: tileValue,
    })
  }, [tileValue])

  return (
    <Box sx={{ textAlign: 'left' }}>
      <Box>
        <Typography variant="subtitle1" fontSize={{ xs: '16px', sm: '20px' }}>
          {preHeader || ''}
        </Typography>
      </Box>
      <Box mb={1}>
        <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
          {header || "Let's start with your basic information:"}
          {helpText !== '' ? (
            <Tooltip
              TransitionComponent={Fade}
              title={
                helpText || 'This helps us calculate your retirement benefits'
              }
              placement="top"
              color="info"
            >
              <IconButton size="small" color="dark">
                <HelpIcon sx={{ marginTop: '-6px' }} />
              </IconButton>
            </Tooltip>
          ) : (
            <></>
          )}
        </Typography>
      </Box>
      <Typography
        variant="body1"
        sx={{ lineHeight: '1.2' }}
        fontSize={{ xs: '16px', sm: '20px' }}
      >
        {subHeader ||
          'Let us know your name and other basic details about you!'}
      </Typography>
      <Box my={4}>
        <Grid container spacing={1} justifyContent="center" mb={3}>
          <Grid item xs={6}>
            <StyledMSB
              active={tileValue === 'married'}
              onClick={() => toggleTileValue('married')}
            >
              <Typography variant="h6" textTransform="capitalize">
                Married
              </Typography>
            </StyledMSB>
          </Grid>
          <Grid item xs={6}>
            <StyledMSB
              active={tileValue === 'single'}
              onClick={() => toggleTileValue('single')}
            >
              <Typography variant="h6" textTransform="capitalize">
                Single
              </Typography>
            </StyledMSB>
          </Grid>
          <Grid item xs={6}>
            <StyledMSB
              active={tileValue === 'divorced'}
              onClick={() => toggleTileValue('divorced')}
            >
              <Typography variant="h6" textTransform="capitalize">
                Divorced
              </Typography>
            </StyledMSB>
          </Grid>
          <Grid item xs={6}>
            <StyledMSB
              active={tileValue === 'widow'}
              onClick={() => toggleTileValue('widow')}
            >
              <Typography variant="h6" textTransform="capitalize">
                Widow/Widower
              </Typography>
            </StyledMSB>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default OnboardingMaritalStatus
